import MobileDetect from 'mobile-detect';
import {media} from "./responsive";
import {createContext, FC, useState} from "react";

/** server-side script for guessing user Viewport if its Mobile/Tablet or others. This initial Viewport is used in our ViewportProvider which then runs the Viewport detection client-side */
export const getViewportFromUserAgent = (
    userAgent: string | null
): string => {
    // corporate firewalls or users who like to stay unknown
    if (!userAgent) {
        return media.lg;
    }

    const device = new MobileDetect(userAgent);

    const isMobile = device.mobile();
    const isTablet = device.tablet();

    if (isMobile && !isTablet) {
        // Our "xs" viewport is given for phones our Tenants do not really support since they are below the 5%, so our best bet is to handle phones like they are sm
        return media.sm;
    }

    if (isTablet) {
        // we understand they can be rotated etc, once again best educated guess
        return media.md;
    }

    // we handle mobile first
    return media.lg;
};

export function addViewportState(userAgent: string | null, pageProps: any) {
    if (pageProps?.props) {
        pageProps.props["__UA__"] = userAgent
    }

    return pageProps
}


export function useViewport(pageProps: any) {
    return pageProps["__UA__"];
}

type TViewportProps = {
    children: React.ReactNode;
    // on the server-side Request we use the user agent to create a best educated guess for its Viewport using user agent and library
    initialViewport: string;
};

const defaultValue = {};
export const ViewportContext = createContext(defaultValue);
export const ViewportProvider: FC<TViewportProps> = ({
                                                  children,
                                                  initialViewport,
                                              }) => {
    const [viewport, setViewport] = useState<string>(
        initialViewport
    );
   
    return (
        <ViewportContext.Provider value={viewport}>
    {children}
    </ViewportContext.Provider>
);
};
